import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, A11y } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".cards-carousel-swiper").forEach((element) => {
    new Swiper(element, {
      modules: [Navigation, Pagination, Autoplay, A11y],
      slidesPerView: 1,
      breakpoints: {
        570: {
          slidesPerView: 2,
          autoHeight: false,
        },
        900: {
          slidesPerView: parseInt(element.dataset.columns, 10),
        },
      },
      breakpointsBase: 'container',
      spaceBetween: 40,
      simulateTouch: false,
      watchOverflow: false,
      autoHeight: element.dataset.autoplay != "1" ? true : false,
      navigation: {
        enabled: element.dataset.navigation == "1",
        prevEl: element.closest(".swiper-parent").querySelector(".swiper-navigation .prev"),
        nextEl: element.closest(".swiper-parent").querySelector(".swiper-navigation .next"),
      },
      pagination: {
        enabled: element.dataset.pagination == "1",
        el: element.closest(".swiper-parent").querySelector(".swiper-pagination"),
        clickable: true,
      },
      loop: element.dataset.loop == "1",
      autoplay:
        element.dataset.autoplay == "1"
        ? {
          delay: parseFloat(element.dataset.autoplayDelay) * 1000
        }
        : false,
    });
  });
});
